<template>
    <v-container class="l-splitlayout">
        <v-row>
            <v-col :cols="leftCols" :md="mdLeftCols" v-bind="leftProps">
                <slot name="left">
                </slot>
            </v-col>
            <v-col :cols="rightCols" :md="mdRightCols" v-bind="rightProps">
                <slot name="right">
                </slot>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

/**
 * Component SplitLayout.vue
 *
 * @module SplitLayout
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/layout/SplitLayout.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'SplitLayout',
  props: {
    leftCols: {
      type: Number,
      default: () => 12
    },
    rightCols: {
      type: Number,
      default: () => 12
    },
    mdLeftCols: {
      type: Number,
      default: () => 7
    },
    mdRightCols: {
      type: Number,
      default: () => 5
    },
    leftProps : {},
    rightProps: {}
  }
}
</script>

<style lang="scss">
    // large screens
    .v-application.md-up .l-splitlayout{
        margin-top: 50px;
    }
</style>
